import axios from "axios";

export const state = {
    reportsharepermembers: [],
};

export const getters = {
    reportsharepermembers: state => state.reportsharepermembers,
};

export const mutations = {
    setReportSharesPerMember(reportsharepermembers, newValue) { state.reportsharepermembers = newValue},
};

export const actions = {
    async fetchReportSharesPerMember({ commit }) {
        await axios.get('/reportsharespermembers').then(res => {
            commit('setReportSharesPerMember', res.data.shares)
        })
    },
    async filterReportSharesPerMember({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportsharespermembers";
        await axios.post(url, formData).then((response) => {
            commit('setReportSharesPerMember', response.data.shares)
        })
    },
};
